angular.module('MW.InsDashboard.SocialReachWidget.SocialReachTooltipRenderer', [
    'MW.Framework.TranslationService',
    'MW.InsDashboard.SocialReachWidget.SocialReachChartDataFormattingService',
    'MW.Framework.CoreUserService'
])
.factory('SocialReachTooltipOptions', function () {
    'use strict';
    function SocialReachTooltipOptions (options) {
        if(!options) {
            options = {};
        }
        if(options && typeof options !== 'object') {
            throw new TypeError('options provided must be an object! Value provided: ' + options);
        }

        if(!options.dateFrom || !moment(options.dateFrom).isValid()) {
            throw TypeError('dateFrom must be a valid date time (string, Date, or moment)');
        }
        this.dateFrom = moment(options.dateFrom);

        if(!options.dateTo || !moment(options.dateTo).isValid()) {
            throw TypeError('dateTo must be a valid date time (string, Date, or moment)');
        }
        this.dateTo = moment(options.dateTo);

        this.change = options.change || 0;
        this.searchName = options.searchName || '';
        this.totalCount = options.totalCount || 0;
        this.facebookCount = options.facebookCount || 0;
        this.facebookPercentage = options.facebookPercentage || 0;
        this.showChange = options.showChange === true;
        this.twitterCount = options.twitterCount || 0;
        this.twitterPercentage = options.twitterPercentage || 0;
        this.youTubeCount = options.youTubeCount || 0;
        this.youTubePercentage = options.youTubePercentage || 0;

        return this;
    }

    return SocialReachTooltipOptions;
})
.service('SocialReachTooltipRenderer', [
    'CoreUserService',
    'SocialReachChartDataFormattingService',
    'SocialReachTooltipOptions',
    'translationService',
    '$filter',
    '$interpolate',
    function SocialReachTooltipRenderer (CoreUserService, SocialReachChartDataFormattingService, SocialReachTooltipOptions, translationService, $filter, $interpolate) {
        'use strict';
        function formatCount (count) {
            if(count === 0) {
                return '0.00';
            }
            return SocialReachChartDataFormattingService.formatFixedDecimalCountDataLabels(count, 2);
        }

        function formatPercentage (percentage) {
            return percentage.toFixed(2);
        }

        function renderTooltip (options) {
            var tooltipTemplate,
                model;

            if (!(options instanceof SocialReachTooltipOptions)) {
                throw new TypeError('options must be type SocialReachTooltipOptions');
            }

            model = {
                showChange: options.showChange,
                change: formatPercentage(options.change),
                changeLabel: translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change'),
                dateFrom: options.dateFrom.tz(CoreUserService.getTimezone()).format('MMM D, YYYY'),
                dateTo: options.dateTo.tz(CoreUserService.getTimezone()).format('MMM D, YYYY'),
                searchName: options.searchName,
                totalCount: formatCount(options.totalCount),
                totalCountLabel: translationService.getLocalizedString('social-reach-widget__tooltip--total-count'),
                facebookCount: formatCount(options.facebookCount),
                facebookPercentage: formatPercentage(options.facebookPercentage),
                twitterCount: formatCount(options.twitterCount),
                twitterPercentage: formatPercentage(options.twitterPercentage),
                youTubeCount: formatCount(options.youTubeCount),
                youTubePercentage: formatPercentage(options.youTubePercentage)
            };

            tooltipTemplate = $interpolate(
                '<b>{{searchName}} ({{dateFrom}} - {{dateTo}})</b><br />' +
                'YouTube {{youTubeCount}} / {{youTubePercentage}}%<br />' +
                'Twitter {{twitterCount}} / {{twitterPercentage}}%<br />' +
                'Facebook {{facebookCount}} / {{facebookPercentage}}%<br />' +
                '{{totalCountLabel}} {{totalCount}} / 100%<br />' +
                (model.showChange ? '{{changeLabel}} {{change}}%' : '')
            );

            return tooltipTemplate(model);
        }

        return {
            render: renderTooltip
        };
    }
]);
